import * as React from "react";
import Jumbotron from "../components/Jumbotron/Jumbotron";
import Property from "../components/Property/Property";
import PropertyInfo from "../components/PropertyInfo/PropertyInfo";
import Footer from "../components/Footer/Footer";

import landing from "../images/properties-landing.jpg";
import smallpic from "../images/properties-landing-sm.jpg";

import classes from "../Stylesheets/properties.module.css";

interface IProps {
  properties: PropertyModel[];
  totalProperties: number | null;
  totalStates: number | null;
}

interface IState {
  showInfo: boolean;
  clickedProperty?: PropertyModel | undefined;
}

interface PropertyModel {
  name: string;
  location: string;
  units: number;
  description: string;
  thumbnail: string;
  picture: string;
  sortOrder?: null | number;
}

class Properties extends React.Component<IProps, IState> {
  state: IState = {
    showInfo: false,
    clickedProperty: undefined,
  };

  scrollAnchorRef: React.RefObject<HTMLDivElement> = React.createRef();

  clickedPropertyHandler = (object: PropertyModel) => {
    this.setState({ showInfo: true, clickedProperty: object });
    const anchor = this.scrollAnchorRef;
    if (anchor.current) {
      anchor.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else {
      return;
    }
  };
  closeHandler = () => {
    this.setState({ showInfo: false });
  };

  render() {
    return (
      <section className="parent">
        <Jumbotron image={landing} preimage={smallpic} title="Our Properties" />
        <section className={classes["mainText"]}>
          <h1>Taking Pride in Our Community</h1>
          <p>
            American Community Developers owns {this.props.totalProperties} residential properties in {this.props.totalStates} states. Here
            are just a few:
          </p>
        </section>
        <div ref={this.scrollAnchorRef} className="parent">
          {this.state.showInfo && this.state.clickedProperty !== undefined ? (
            <PropertyInfo
              photo={this.state.clickedProperty.picture}
              location={this.state.clickedProperty.location}
              units={this.state.clickedProperty.units}
              clicked={() => this.closeHandler()}
            />
          ) : null}
        </div>
        <section className={classes["properties"]}>
          {this.props.properties.map((property, index) => {
            return (
              <Property name={property.name} key={index} photo={property.thumbnail} clicked={() => this.clickedPropertyHandler(property)} />
            );
          })}
        </section>
        <Footer />
      </section>
    );
  }
}

export default Properties;
